/**
 * 共通スクリプト即時実行部
 *
 * 履歴：
 * No.    日付          更新者    更新内容
 *   1    2021/04/20            新規作成
 *
 * @summary 共通スクリプト即時実行部
 * @copyright 2021, WINGSYSTEMS K.K.
 */
'use strict';

import {BlockUI} from './common/blockui';
import {Page} from './common/page';

(function(){

    // ページトップに移動する
    Page.PageTop.build();

    // 共通Trim処理
    document.querySelectorAll('input').forEach(element => {
        element.addEventListener('blur', event => {
            element.value = element.value.trim();
        });
    });

    // safariだとブラウザバックで戻るとブロックが解除されない
    // Form.jsでやっていたものを持ってきた
    const onPageHide = function(event) {BlockUI.hide();};
    window.removeEventListener('pagehide', onPageHide);
    window.addEventListener('pagehide', onPageHide);
//    $(window).off('pagehide');
//    $(window).on('pagehide', function(){
//        BlockUI.unblockUI();
//    });

//    // tooltip
//    $('[data-toggle="tooltip"]').tooltip();
//    $('[data-toggle="tooltip"]').on('show.bs.tooltip', function(){
//        var title = this.getAttribute('data-original-title');
//        if (title !== Str.stripTagByScript(title)) {
//            // scriptタグが含まれる場合は表示しない
//            console.log('not use <script>: ' + title);
//            return false;
//        }
//    });
//
//    if (Svr.Request.Controller !== 'login') {
//        // ログイン画面以外
//        // Enterキーの許可判定（テキストエリアタグ,ボタンのみ許可する）
//        $(window).keypress(function(ev){
//            if ((ev.which && ev.which === 13) || (ev.keyCode && ev.keyCode === 13)) {
//                if (document.activeElement.type === 'textarea'
//                        || document.activeElement.type === 'button'
//                        || document.activeElement.type === 'submit'
//                        || document.activeElement.type === 'reset') {
//                    return true;
//                } else {
//                    return false;
//                }
//            } else {
//                return true;
//            }
//        });
//        // get_flashアラート
//        Api.Messages.flash();
//    }

    // 動的にviewport変更 幅480未満対応
    (function(baseW){
        //var baseW = 480;  //基準となるブレークポイント
        var iOSviewportW = 0;
        var ua = navigator.userAgent.toLowerCase();
        var isiOS = (ua.indexOf("iphone") > -1) || (ua.indexOf("ipod") > -1) || (ua.indexOf("ipad") > -1);
        if (isiOS) {
            iOSviewportW = document.documentElement.clientWidth;
        }
        function updateMetaViewport (){
            var viewportContent;
            var w = window.outerWidth;
            if (isiOS) {
                w = iOSviewportW;
            }
            //console.log(w , baseW);
            if (w < baseW) {
                viewportContent = "width=" + baseW + ",shrink-to-fit=yes";
            } else {
                viewportContent = "width=device-width,initial-scale=1.0,shrink-to-fit=yes";
            }
            document.querySelector("meta[name='viewport']").setAttribute("content", viewportContent);
        }
        //イベントハンドラ登録
        window.addEventListener("resize", updateMetaViewport, false);
        window.addEventListener("orientationchange", updateMetaViewport, false);
        //初回イベント強制発動
        var ev = document.createEvent("UIEvent");
        ev.initEvent("resize", true, true);
        window.dispatchEvent(ev);
    }(375));
})();
